import CountUp from 'react-countup';

interface Props {
  /** The current number to count up to. */
  currentCount: number;

  /** A label to be displayed after the count (without a space separator). */
  label: string;

  /**
   * Optional delay in seconds before the counting animation starts.
   * @default 0
   */
  delay?: number;

  /**
   * The number to start counting from.
   * @default 0
   */
  prevCount?: number;
}

/**
 * Displays an animated count-up number with a label suffix.
 *
 * @param props - Component props
 * @returns A React component that renders the animated number or `null` if `currentCount` is invalid.
 */
export function CountNumberUp(props: Props) {
  const { currentCount, label, delay = 0, prevCount = 0 } = props;

  if (!currentCount && currentCount !== 0) return null;

  return (
    <CountUp
      start={prevCount}
      end={currentCount}
      delay={delay}
      suffix={` ${label}`}
    >
      {({ countUpRef }) => (
        <div>
          <span ref={countUpRef} />
        </div>
      )}
    </CountUp>
  );
}
